<template>
  <div class="page" :style="{ height: fixedHeight + 'px' }">
    <div class="searchBox">
      <el-form>
        <el-row>
          <el-col :span="6">
            <el-form-item>
              <el-input
                style="width: 200px; margin-right: 10px"
                placeholder="请输入关键字"
                v-model="params.keywords"
                @keyup.enter.native="changeSearch"
                clearable
                size="small"
              ></el-input>
              <el-button
                @click="changeSearch"
                icon="el-icon-search"
                type="warning"
                size="small"
                >搜索</el-button
              >
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-form-item label="门店" :label-width="'40px'">
              <el-select
                v-model="params.shopId"
                placeholder="请选择"
                clearable
                @change="changeSearch"
                size="small"
                style="width: 100px"
              >
                <el-option
                  v-for="item in this.$store.state.userInfo.shops"
                  :key="item.shop_id"
                  :label="item.shop_name"
                  :value="item.shop_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="盘库时间" :label-width="'80px'">
              <el-date-picker
                style="width: 250px"
                v-model="dateTime"
                type="daterange"
                range-separator="-"
                value-format="timestamp"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="changeDate"
                size="small"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <resetBtn @reset="reset"></resetBtn>
          </el-col>
          <el-col :span="2" style="text-align: right">
            <el-button
              @click="handleClick"
              type="warning"
              size="small"
              >新建</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="pageConBox">
      <el-table
        default-expand-all
        :data="tableData"
        style="width: 100%"
        ref="table"
      >
        <el-table-column label="盘点期号" prop="no">
          <template slot-scope="scope">
            <span>{{ scope.row.no }}</span>
          </template>
        </el-table-column>
<!--        <el-table-column label="编号" prop="id"> </el-table-column>-->
        <el-table-column label="盘库时间">
          <template slot-scope="scope">
            <span>{{ scope.row.inventoryTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="盘库人" prop="outUserName"> 
          <template slot-scope="scope">
            <span>{{ scope.row.inventoryUser.title }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="see(scope.row.id)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <page
        :page="page.page"
        :total="page.total"
        :pageSize="page.pageSize"
        @change="pageChange"
        style="padding: 20px 0"
      ></page>
    </div>
    <div v-if="drawerSee_state">
      <drawerSee :id="curId" @submit="submit_drawerSee"></drawerSee>
    </div>
  </div>
</template>
<script>
import page from "@/components/page.vue";
import resetBtn from "../../../components/resetBtn.vue";
import drawerSee from "./drawerSee.vue";
export default {
  components: {
    page,
    resetBtn,
    drawerSee
  },
  data() {
    return {
      fixedHeight: "",
      tableData: [],
      dateTime: [],
      params: {
        inventoryDateStart: "", // 入库查询开始日期
        inventoryDateEnd: "", // 入库查询结束日期
        shopId: this.$store.getters.curShopInfo.shop_id,
        keywords: "",
      },
      // 当前tab
      curTabIndex: 0,
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      goodscustom: "",
      trackData: "",
      splitCustomCodeParams: {
        splitTimes: 1,
        goodsCustomCode: "",
        useShopId: "",
      },
      // 查看
      drawerSee_state: false,
      curId: "",
    };
  },
  created() {
    this.fixedHeight = document.documentElement.clientHeight - 76;
  },
  mounted() {
    this.getTableData();
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    curShopId() {
      return this.$store.state.shopId;
    },

  },
  methods: {
    handleClick(){
      this.$router.push({
					path: 'pandianAdd'
				})
    },
    // 查看
    see(id) {
      this.drawerSee_state = true;
      this.curId = id;
    },
    submit_drawerSee() {
      this.drawerSee_state = false;
    },
    reset() {
      this.params.inventoryDateStart = "";
      this.params.inventoryDateEnd = "";
      this.params.keywords = "";
      this.dateTime = [];
      this.page.page = 1;
      this.getTableData();
    },
    changeDate() {
      this.page.page = 1;
      this.params.inventoryDateStart = this.dateTime ? this.dateTime[0] : "";
      this.params.inventoryDateEnd = this.dateTime ? this.dateTime[1] : "";
      this.getTableData();
    },
    changeSearch() {
      this.page.page = 1;
      this.getTableData();
    },
    // 改变分页
    pageChange(num) {
      this.page.page = num;
      this.getTableData();
    },
    getTableData() {
      let params = {
        keywords: this.params.keywords,
        shopId: this.params.shopId,
        inventoryDateStart: this.$public.FTime(this.params.inventoryDateStart),
        inventoryDateEnd: this.$public.FTime(this.params.inventoryDateEnd),
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
      };
      let loading = this.$loading();
      this.$http
        .post(process.env.VUE_APP_Url66 + "api/inventory/list", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.page.total = res.data.count;
          }
        });
    },
    toogleExpand(row) {
      let $table = this.$refs.table;
      this.tableData.map((item) => {
        if (row.skus != item.skus) {
          $table.toggleRowExpansion(item, false);
        }
      });
      $table.toggleRowExpansion(row);
    }

  },
};
</script>
<style scoped lang="scss">
.page {
  display: flex;
  flex-direction: column;
  .searchBox {
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .tabLine {
    margin-top: 12px;
    display: flex;
    .tabItem {
      padding: 0 16px;
      line-height: 36px;
      text-align: center;
      border-right: 1px solid #f2f2f2;
      cursor: pointer;
      font-size: 14px;
      background-color: #fff;
      &.active {
        color: $mainColor;
      }
    }
  }
  .pageConBox {
    flex: 1;
    border-right: 1px solid #f2f2f2;
    min-height: 0;
  }
}
</style>
